/*
 * @author Maksym Shutiak <maxshutyak>
 */
const gccsPlanningTutorialShifts = {
  template: require('./template.pug')
};

angular.module('public.security-manager.schedule-manager.timeline.planning')
  .component('gccsPlanningTutorialShifts', gccsPlanningTutorialShifts);
